export const SALES_PHONE_NUMBER = '01 88 32 12 69'
export const SALES_PHONE_NUMBER_WITH_COUNTRY_CODE = '+33188321269'
export const SUPPORT_EMAIL_ADDRESS = 'support@closd.com'
